module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_train-fa4013ca6d1e12081c85caf35a07d8be.svg";